module.exports = __webpack_public_path__ + "static/media/icon-piece6-6.b7d5d51e.png";